import axios from "axios";
import { base_URL } from '../config/config';
const API_BASE_URL = `${base_URL}/api`;

export const getCustomers = async (page = 1, limit = 10, filter, searchQuery = null) => {
  try {
    const accessToken = localStorage.getItem("adminAccessToken");
    if(searchQuery && searchQuery !== "") filter = { ...filter, globalSearch: { value: searchQuery, type: "user" }}
    const response = await axios.get(`${API_BASE_URL}/customer/list`, {
      params: { page, itemPerPage: limit, filter: JSON.stringify(filter) },
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return response.data;
  }
  catch(error) {
    console.log('Error fetching customers', error);
    throw error;
  }
}

export const exportCustomers = async ({ fromDate, toDate }) => {
    try {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.get(`${API_BASE_URL}/customer/list/export`, {
      params: { fromDate, toDate  },
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    return response.data;
  }
  catch(error) {
    console.log('Error fetching customers', error);
    throw error;
  }
}